(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function(cents){ return '\u20B9' + (cents/100).toLocaleString('en-IN',{minimumFractionDigits:0,maximumFractionDigits:2}); };

  var ann = document.querySelector('[data-ann]');
  if (ann) {
    var msgs = ann.querySelectorAll('.ann__msg');
    if (msgs.length > 1 && !reduce) {
      var ai = 0, delay = parseInt(ann.dataset.ann, 10) || 4000;
      setInterval(function(){ msgs[ai].hidden = true; ai = (ai + 1) % msgs.length; msgs[ai].hidden = false; }, delay);
    }
  }

  var hdr = document.querySelector('[data-transparent]');
  if (hdr) { var onScroll = function(){ hdr.classList.toggle('is-solid', window.scrollY > 40); }; window.addEventListener('scroll', onScroll, {passive:true}); onScroll(); }

  var mt = document.querySelector('[data-menu-toggle]'), menu = document.querySelector('[data-menu]');
  if (mt && menu) { mt.addEventListener('click', function(){ var open = menu.hidden; menu.hidden = !open; mt.setAttribute('aria-expanded', String(open)); }); }

  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var dots = document.querySelectorAll('[data-dots="' + g.dataset.gallery + '"] .dot');
    g.addEventListener('scroll', function(){
      var n = Math.round(g.scrollLeft / g.clientWidth);
      dots.forEach(function(d, k){ d.setAttribute('aria-current', k === n ? 'true' : 'false'); });
    }, { passive: true });
  });

  document.querySelectorAll('[data-faq]').forEach(function(root){
    root.querySelectorAll('.faq__q').forEach(function(btn){
      btn.addEventListener('click', function(){
        var open = btn.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('.faq__q').forEach(function(b){
          b.setAttribute('aria-expanded','false');
          b.querySelector('span').textContent = '+';
          var t = document.getElementById(b.getAttribute('aria-controls')); if (t) t.hidden = true;
        });
        if (!open) {
          btn.setAttribute('aria-expanded','true');
          btn.querySelector('span').textContent = '\u2212';
          var el = document.getElementById(btn.getAttribute('aria-controls')); if (el) el.hidden = false;
        }
      });
    });
  });

  var drawer = document.querySelector('[data-drawer]');
  var itemsEl = document.querySelector('[data-drawer-items]');
  var totalEl = document.querySelector('[data-drawer-total]');
  var noteEl = document.querySelector('[data-drawer-note]');
  var countEl = document.querySelector('[data-cart-count]');
  var upsell = document.querySelector('[data-upsell]');
  var shipEl = document.querySelector('[data-ship]');

  function openDrawer(){ if(!drawer) return; drawer.hidden = false; requestAnimationFrame(function(){ drawer.classList.add('is-open'); }); document.body.style.overflow='hidden'; }
  function closeDrawer(){ if(!drawer) return; drawer.classList.remove('is-open'); document.body.style.overflow=''; setTimeout(function(){ drawer.hidden = true; }, 220); }

  function renderCart(cart){
    if (countEl) countEl.textContent = cart.item_count;
    if (!itemsEl) return;
    if (!cart.items.length) { itemsEl.innerHTML = '<p class="drawer__empty">Your cart is empty.</p>'; }
    else {
      itemsEl.innerHTML = cart.items.map(function(i){
        var img = i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2') + '" alt="">' : '';
        var opt = i.variant_title ? '<span class="caption">' + i.variant_title + '</span>' : '';
        var pref = (i.properties && i.properties['Payment preference']) ? '<span class="caption">' + i.properties['Payment preference'] + '</span>' : '';
        return '<div class="drawer__line">' + img + '<div style="flex:1"><b>' + i.product_title + '</b>' + opt + pref + '</div><b>' + money(i.final_line_price) + '</b></div>';
      }).join('');
    }
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (upsell) {
      var id = upsell.querySelector('[data-upsell-add]').dataset.variant;
      var already = cart.items.some(function(i){ return String(i.variant_id) === String(id); });
      upsell.hidden = already || !cart.items.length;
    }
    if (shipEl) {
      var th = parseInt(shipEl.dataset.threshold, 10) || 0;
      var pct = Math.min(100, Math.round(cart.total_price / th * 100));
      shipEl.querySelector('[data-ship-fill]').style.width = pct + '%';
      shipEl.querySelector('[data-ship-text]').textContent = cart.total_price >= th
        ? 'Free shipping applied.'
        : money(th - cart.total_price) + ' away from free shipping.';
    }
    if (noteEl) {
      var pay = document.querySelector('.pay__opt[aria-checked="true"]');
      noteEl.textContent = pay && pay.dataset.pay && pay.dataset.pay.toLowerCase().indexOf('online') > -1
        ? 'Online saving applied automatically at checkout' : 'Shipping calculated at checkout';
    }
  }

  function fetchCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart); }
  if (drawer) fetchCart();

  document.querySelectorAll('[data-drawer-close]').forEach(function(b){ b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer(); });
  var cartOpen = document.querySelector('[data-cart-open]');
  if (cartOpen && drawer) cartOpen.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); fetchCart(); });

  var form = document.getElementById('buy-form');
  if (form && drawer) {
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btns = form.querySelectorAll('button[name="add"]');
      btns.forEach(function(b){ b.disabled = true; });
      fetch('/cart/add.js', { method:'POST', body: new FormData(form) })
        .then(function(r){ return r.json(); })
        .then(function(){ return fetchCart(); })
        .then(function(){ openDrawer(); })
        .catch(function(){ form.submit(); })
        .finally(function(){ btns.forEach(function(b){ b.disabled = false; }); });
    });
  }

  var upsellBtn = document.querySelector('[data-upsell-add]');
  if (upsellBtn) {
    upsellBtn.addEventListener('click', function(){
      upsellBtn.disabled = true;
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: upsellBtn.dataset.variant, quantity: 1 }) })
        .then(function(){ return fetchCart(); })
        .finally(function(){ upsellBtn.disabled = false; });
    });
  }

  var buy = document.querySelector('[data-buy]');
  if (buy) {
    var input = buy.querySelector('[data-variant-input]');
    var payInput = buy.querySelector('[data-pay-input]');
    var priceEl = buy.querySelector('[data-price]');
    var unitEl = buy.querySelector('[data-unit]');
    var saveEl = buy.querySelector('[data-save]');
    var onlineEl = buy.querySelector('[data-online]');
    var codEl = buy.querySelector('[data-cod]');
    var nameEl = document.querySelector('[data-sticky-name]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var first = buy.querySelector('.tier[aria-checked="true"]');
    var apply = function(t){
      if (input) input.value = t.dataset.variant;
      if (priceEl) priceEl.textContent = t.dataset.price;
      if (unitEl) unitEl.textContent = t.dataset.unit;
      if (saveEl) saveEl.textContent = t.dataset.save;
      if (onlineEl) onlineEl.textContent = t.dataset.online;
      if (codEl) codEl.textContent = t.dataset.cod;
      if (nameEl) nameEl.textContent = t.dataset.name;
      if (stickyPrice) stickyPrice.textContent = t.dataset.price;
    };
    if (first) apply(first);
    buy.querySelectorAll('.tier').forEach(function(t){
      t.addEventListener('click', function(){
        if (t.disabled) return;
        buy.querySelectorAll('.tier').forEach(function(x){ x.setAttribute('aria-checked','false'); });
        t.setAttribute('aria-checked','true');
        apply(t);
        var url = new URL(window.location); url.searchParams.set('variant', t.dataset.variant);
        window.history.replaceState({}, '', url);
      });
    });
    buy.querySelectorAll('.pay__opt').forEach(function(p){
      p.addEventListener('click', function(){
        buy.querySelectorAll('.pay__opt').forEach(function(x){ x.setAttribute('aria-checked','false'); });
        p.setAttribute('aria-checked','true');
        if (payInput) payInput.value = p.dataset.pay;
      });
    });
  }

  var bar = document.querySelector('.sticky-atc');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(entries){
      var off = !entries[0].isIntersecting;
      bar.classList.toggle('is-on', off);
      bar.setAttribute('aria-hidden', String(!off));
    }, { threshold: 0 }).observe(anchor);
  }

  var pin = document.querySelector('[data-pincode]');
  if (pin) {
    pin.querySelector('button').addEventListener('click', function(){
      var v = pin.querySelector('input').value.replace(/\D/g,'');
      var out = pin.querySelector('[data-pin-result]');
      out.hidden = false;
      out.textContent = v.length === 6 ? pin.dataset.pincode : 'Enter all six digits.';
    });
  }
})();
